import { render, staticRenderFns } from "./CardService.vue?vue&type=template&id=61ba92b7&scoped=true&"
import script from "./CardService.vue?vue&type=script&lang=js&"
export * from "./CardService.vue?vue&type=script&lang=js&"
import style0 from "./CardService.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CardService.vue?vue&type=style&index=1&id=61ba92b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba92b7",
  null
  
)

export default component.exports